import {directive} from 'vue-clickaway'
import {Loading} from 'element-ui'
import VueDOMPurifyHTML from 'vue-dompurify-html'

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', directive)
    Vue.use(Loading.directive)
    Vue.use(VueDOMPurifyHTML, {
      default: { USE_PROFILES: { html: false } },
      namedConfigurations: {
        safeHtml: { USE_PROFILES: { html: true } }
      }
    })
  }
}

export default GlobalDirectives
